export enum CareTopic {
  OfficeVisit = 'officeVisit',
  RemoteVisit = 'remoteVisit',
  RoutineVisit = 'routineVisit',
  CovidCare = 'covidCare',
  CovidCareWithHomeKits = 'covidCareWithHomeKits',
  PediatricMeetAndGreet = 'pediatricMeetAndGreet',
  Wellbeing = 'wellbeing',
  MentalHealth = 'mentalHealth',
  GroupTherapy = 'groupTherapy',
  ChronicConditions = 'chronicConditions',
  SexualHealth = 'sexualHealth',
  GenericVisit = 'genericVisit',
}
